"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var apiService_1 = __importStar(require("@common/services/apiService"));
var implio_logo_color_svg_1 = __importDefault(require("@assets/implio_logo_color.svg"));
var SelectDropdown_1 = __importDefault(require("@/react-app/common/components/SelectDropdown"));
var handleAuth0redirect_1 = require("@/react-app/common/utils/handleAuth0redirect");
var InputUnderlined_1 = __importDefault(require("@/react-app/common/components/InputUnderlined"));
var Loading_1 = __importDefault(require("@/react-app/common/components/Loading"));
var constants_1 = require("@/react-app/common/constants");
var userSettings_1 = require("@/react-app/common/utils/userSettings");
var notifier_1 = __importDefault(require("@/react-app/common/utils/notifier"));
var i18n_1 = __importDefault(require("@/react-app/i18n"));
var MAX_INPUT_LENGTH = 30;
var POLLING_RETRIES = 20;
var POLLING_INTERVAL = 3000;
var regions = [
    { id: 'europe', text: i18n_1.default.t('CREATE_TEAM.REGIONS_LABEL.EUROPE') },
    { id: 'south-america', text: i18n_1.default.t('CREATE_TEAM.REGIONS_LABEL.LATIN_AMERICA') },
    { id: 'north-america', text: i18n_1.default.t('CREATE_TEAM.REGIONS_LABEL.NORTH_AMERICA') },
    { id: 'asia-pacific', text: i18n_1.default.t('CREATE_TEAM.REGIONS_LABEL.ASIA') },
    { id: 'africa', text: i18n_1.default.t('CREATE_TEAM.REGIONS_LABEL.AFRICA') },
    { id: 'middle-east', text: i18n_1.default.t('CREATE_TEAM.REGIONS_LABEL.MIDDLE_EAST') },
    { id: 'oceania', text: i18n_1.default.t('CREATE_TEAM.REGIONS_LABEL.OCEANIA') },
];
function CreateTeamPage(_a) {
    var _this = this;
    var angularJsDependencies = _a.angularJsDependencies, goToDefault = _a.goToDefault;
    var t = (0, react_i18next_1.useTranslation)().t;
    var CurrentUser = angularJsDependencies.CurrentUser;
    var hasUnsafeChars = function (value) { return constants_1.unsafeCharacters.some(function (char) { return value.includes(char); }); };
    var _b = __read((0, react_1.useState)(regions[0].id), 2), region = _b[0], setRegion = _b[1];
    var _c = __read((0, react_1.useState)(''), 2), teamName = _c[0], setTeamName = _c[1];
    var _d = __read((0, react_1.useState)(''), 2), company = _d[0], setCompany = _d[1];
    var _e = __read((0, react_1.useState)(''), 2), teamNameError = _e[0], setTeamNameError = _e[1];
    var _f = __read((0, react_1.useState)(''), 2), companyNameError = _f[0], setCompanyNameError = _f[1];
    var _g = __read((0, react_1.useState)(''), 2), formError = _g[0], setFormError = _g[1];
    var _h = __read((0, react_1.useState)(false), 2), loading = _h[0], setLoading = _h[1];
    var timeoutRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        apiService_1.default.getUserLocation().then(function (_a) {
            var continentId = _a.data.continentId;
            if (continentId)
                setRegion(continentId);
        });
    }, []);
    (0, react_1.useEffect)(function () {
        return function () {
            if (timeoutRef.current)
                clearTimeout(timeoutRef.current);
        };
    }, []);
    var validateTeamName = function (name) {
        var errorMessage = '';
        if (!name.trim())
            errorMessage = t('CREATE_TEAM.ERROR.TEAM_REQUIRED');
        else if (name.length > MAX_INPUT_LENGTH)
            errorMessage = t('CREATE_TEAM.ERROR.TEAM_TOO_LONG');
        else if (hasUnsafeChars(name))
            errorMessage = t('CREATE_TEAM.ERROR.UNSAFE_CHARACTERS');
        // Set the error state directly in the validation function
        setTeamNameError(errorMessage);
        return errorMessage;
    };
    var validateCompanyName = function (name) {
        var errorMessage = '';
        if (!name.trim())
            errorMessage = t('CREATE_TEAM.ERROR.COMPANY_NAME_REQUIRED');
        else if (name.length > MAX_INPUT_LENGTH)
            errorMessage = t('CREATE_TEAM.ERROR.COMPANY_TOO_LONG');
        else if (hasUnsafeChars(name))
            errorMessage = t('CREATE_TEAM.ERROR.UNSAFE_CHARACTERS');
        // Set the error state directly in the validation function
        setCompanyNameError(errorMessage);
        return errorMessage;
    };
    /* eslint-disable no-await-in-loop */
    var pollTeamCreationStatus = function (domain) { return __awaiter(_this, void 0, void 0, function () {
        var attempt, data, user, msg, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 8, , 9]);
                    attempt = 1;
                    _a.label = 1;
                case 1:
                    if (!(attempt <= POLLING_RETRIES)) return [3 /*break*/, 7];
                    return [4 /*yield*/, apiService_1.default.getTeamCreationStatus({ domain: domain })];
                case 2:
                    data = (_a.sent()).data;
                    if (!(data.status === 'ready')) return [3 /*break*/, 4];
                    (0, userSettings_1.saveUserSetting)('lastUsedDomain', domain, CurrentUser);
                    setLoading(false);
                    return [4 /*yield*/, apiService_1.default.getUser()];
                case 3:
                    user = _a.sent();
                    CurrentUser.logIn(user.data);
                    goToDefault({ showIntroduction: true });
                    return [2 /*return*/];
                case 4:
                    if (!(attempt < POLLING_RETRIES)) return [3 /*break*/, 6];
                    return [4 /*yield*/, new Promise(function (resolve) {
                            timeoutRef.current = setTimeout(resolve, POLLING_INTERVAL);
                        })];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    attempt++;
                    return [3 /*break*/, 1];
                case 7:
                    msg = t('CREATE_TEAM.ERROR.TEAM_CREATION_ERROR');
                    setFormError(msg);
                    notifier_1.default.error(msg);
                    setLoading(false);
                    return [3 /*break*/, 9];
                case 8:
                    error_1 = _a.sent();
                    setLoading(false);
                    notifier_1.default.error(t('CREATE_TEAM.ERROR.TEAM_CREATION_ERROR'));
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var switchAccount = function () { return (0, handleAuth0redirect_1.handleAuthLogout)(); };
    var submit = function (e) {
        e.preventDefault();
        // Validate fields before submission
        var teamError = validateTeamName(teamName);
        var companyError = validateCompanyName(company);
        if (teamError || companyError) {
            return;
        }
        setFormError('');
        setLoading(true);
        apiService_1.default
            .createTeam(null, {
            teamName: teamName,
            company: company,
            region: region,
        })
            .then(function (_a) {
            var _b;
            var data = _a.data;
            var domain = (_b = data === null || data === void 0 ? void 0 : data.siteAccount) === null || _b === void 0 ? void 0 : _b.domain;
            if (domain) {
                pollTeamCreationStatus(domain);
            }
            else {
                var msg = t('CREATE_TEAM.ERROR.TEAM_CREATION_ERROR');
                notifier_1.default.error(msg);
                setLoading(false);
            }
        })
            .catch(function (error) {
            var _a, _b;
            if ((0, apiService_1.isApiError)(error)) {
                var _c = (error === null || error === void 0 ? void 0 : error.data) || {}, context_1 = _c.context, message = _c.message;
                var status_1 = (_b = (_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : error === null || error === void 0 ? void 0 : error.status;
                if (status_1 === 409 || status_1 === 400) {
                    // 409 if region is invalid (shouldn't happen)
                    if (context_1 === 'region') {
                        var errorToDisplay = message || t('CREATE_TEAM.ERROR.SERVER_ERROR');
                        setFormError(errorToDisplay);
                        notifier_1.default.error(errorToDisplay);
                        // 400 otherwise, means there is an issue with fields
                    }
                    else {
                        notifier_1.default.error(t('CREATE_TEAM.ERROR.ALL_FIELDS_REQUIRED'));
                    }
                    return;
                }
                if (status_1 === -1) {
                    notifier_1.default.error(t('CREATE_TEAM.ERROR.CONNECT_ERROR'));
                    return;
                }
                notifier_1.default.error(t('CREATE_TEAM.ERROR.SERVER_ERROR'));
                return;
            }
            notifier_1.default.error(t('CREATE_TEAM.ERROR.TEAM_CREATION_ERROR'));
            setLoading(false);
        });
    };
    return (react_1.default.createElement("div", { className: "signup-container" },
        react_1.default.createElement("div", { className: "logo-container" },
            react_1.default.createElement("img", { src: implio_logo_color_svg_1.default, width: 200, alt: "Logo" })),
        react_1.default.createElement("h2", { className: "start-title" }, t('CREATE_TEAM.TITLE')),
        react_1.default.createElement("form", { name: "signupForm", className: "form signup", onSubmit: submit },
            react_1.default.createElement(InputUnderlined_1.default, { value: teamName, onTextChange: function (text) {
                    setTeamName(text);
                    validateTeamName(text);
                }, placeholder: t('CREATE_TEAM.TEAM_NAME_PLACEHOLDER'), error: teamNameError, information: t('CREATE_TEAM.TEAM_NAME_TOOLTIP'), className: "sign-up__team-name-container", required: true, onValidate: validateTeamName }),
            react_1.default.createElement(InputUnderlined_1.default, { value: company, onTextChange: function (text) {
                    setCompany(text);
                    validateCompanyName(text);
                }, placeholder: t('CREATE_TEAM.COMPANY_NAME_PLACEHOLDER'), error: companyNameError, className: "sign-up__company-container", required: true, onValidate: validateCompanyName }),
            react_1.default.createElement("div", { className: "select-region" },
                react_1.default.createElement("label", { className: "sign-up__select-region__title" },
                    t('CREATE_TEAM.SERVICE_REGION_LABEL').toLocaleUpperCase(),
                    react_1.default.createElement("div", { className: "eva-tooltip-container--center sign-up__select-region__title__icon-container" },
                        react_1.default.createElement("i", { className: "sign-up__select-region__title__icon implioicons-question-mark-filled" }),
                        react_1.default.createElement("div", { className: "eva-tooltip" }, t('CREATE_TEAM.SERVICE_REGION_TOOLTIP')))),
                react_1.default.createElement(SelectDropdown_1.default, { items: regions, onItemSelected: function (item) {
                        setRegion(item);
                        setFormError('');
                    }, selectedItemId: region }),
                formError && react_1.default.createElement("p", { className: "alert alert-error" }, formError)),
            react_1.default.createElement("div", { className: "terms-of-service" },
                t('CREATE_TEAM.AGREE_POLICY_TEXT'),
                ' ',
                react_1.default.createElement("a", { className: "terms-of-service-link", href: "https://besedo.com/terms-of-service/", target: "_blank", rel: "noreferrer" }, t('CREATE_TEAM.TERMS_OF_SERVICE'))),
            react_1.default.createElement("button", { type: "submit", className: "btn btn-block btn-start", disabled: loading },
                react_1.default.createElement("span", null, loading ? t('CREATE_TEAM.TEAM_CREATION_TEXT') : t('CREATE_TEAM.CREATE_TEAM_BTN')),
                loading && react_1.default.createElement(Loading_1.default, { noCentering: true, color: "white" })),
            react_1.default.createElement("a", { className: "nav-link", onClick: switchAccount }, t('CREATE_TEAM.SWITCH_ACCOUNT')))));
}
exports.default = CreateTeamPage;
